import { Doorstep } from "../components/Doorstep";
import { FadeIn } from "../components/FadeIn";
import { BOOKING_URL, WHATSAPP_URL } from "../data/content";
import { MapPin, Car, ShieldCheck, Clock } from "lucide-react";

export const DoorstepPage = () => {
  return (
    <div className="py-12 sm:py-20 px-4 sm:px-8 lg:px-12">
      {/* Banner */}
      <div className="max-w-7xl mx-auto text-center mb-16">
        <FadeIn>
          <div className="text-xs uppercase tracking-[0.25em] text-red-400 font-extrabold mb-3">
            At Your Residence & Hotel
          </div>
          <h1 className="text-4xl sm:text-6xl font-serif font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-rose-400 to-amber-600 mb-6">
            G69 Doorstep Massage Gurgaon
          </h1>
          <p className="text-white/70 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Can't visit our Sikanderpur sanctuary? We bring the complete spa experience directly to your home, apartment, or hotel suite across Gurugram.
          </p>
        </FadeIn>
      </div>

      <Doorstep />

      {/* Coverage Areas Grid */}
      <div className="max-w-7xl mx-auto mt-20 pt-16 border-t border-white/10">
        <FadeIn>
          <h2 className="text-2xl sm:text-3xl font-serif text-amber-400 font-bold mb-8 text-center">
            Gurugram Coverage Locations
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { title: "DLF Cyber City & Phase 1-5", desc: "Fast 30-45 min arrival" },
              { title: "Golf Course Road & Ext.", desc: "Luxury apartments & penthouses" },
              { title: "Sohna Road & Sector 48-57", desc: "Full doorstep setup" },
              { title: "MG Road & Gurgaon Hotels", desc: "Hotel suite private service" },
            ].map((loc, i) => (
              <div key={i} className="bg-[#0c0c0c] border border-white/10 p-6 rounded-2xl">
                <div className="flex gap-2 items-center text-amber-400 font-bold mb-2">
                  <MapPin className="w-4 h-4" />
                  <h3 className="text-sm text-white font-bold">{loc.title}</h3>
                </div>
                <p className="text-xs text-white/50">{loc.desc}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-amber-300 to-amber-600 text-black font-extrabold px-8 py-3.5 rounded-full text-xs uppercase tracking-[0.15em] text-center shadow-lg hover:scale-105 transition-transform"
            >
              Book Gurgaon Doorstep
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-emerald-600/20 border border-emerald-500/50 text-emerald-400 font-extrabold px-8 py-3.5 rounded-full text-xs uppercase tracking-[0.15em] text-center hover:bg-emerald-600 hover:text-white transition-colors"
            >
              WhatsApp Support
            </a>
          </div>
        </FadeIn>
      </div>
    </div>
  );
};
